import { makeModuleI18nSelector } from "@client/content/selectors";
import { asyncAction } from "@client/lib/actions";
import { type AppState, type EntityRef } from "@client/types";
import { type Dispatch } from "redux";
import api from "./api";
import { getActionFromQS, getEmailFromQS, getSidFromQS } from "./lib";
import { type Unsubscribe } from "./types";

export enum Actions {
  UnsubscribeBegin = "CONTENT_TYPE_UNSUBSCRIBE_UNSUBSCRIBE_BEGIN",
  UnsubscribeFailure = "CONTENT_TYPE_UNSUBSCRIBE_UNSUBSCRIBE_FAILURE",
  UnsubscribeSuccess = "CONTENT_TYPE_UNSUBSCRIBE_UNSUBSCRIBE_SUCCESS"
}

export type UnsubscribeBeginActionData = EntityRef & {
  action?: Unsubscribe.UnsubscribeAction;
  email?: string;
  reason: Unsubscribe.UnsubscribeReason;
  isInstant?: boolean;
};
export const ubsubscribe = asyncAction<AppState, UnsubscribeBeginActionData, void>({
  types: {
    begin: Actions.UnsubscribeBegin,
    failure: Actions.UnsubscribeFailure,
    success: Actions.UnsubscribeSuccess
  },
  action: (state: AppState, dispatch: Dispatch, params: UnsubscribeBeginActionData): Promise<void> => {
    const i18n = makeModuleI18nSelector()(state, params);

    return api.unsubscribe(i18n, {
      scheduleId: getSidFromQS()!,
      email: (params.email || getEmailFromQS())!,
      isGlobal: (params.action || getActionFromQS()) === "all",
      unsubscribeReasonKey: params.reason
    });
  }
});
